import React, { Component } from "react";
import MessageForm from "./../../../components/TwilioProgrammableTextChat/MessageForm";
import MessageList from "./../../../components/TwilioProgrammableTextChat/MessageList";
import TypingIndicator from "./../../../components/TwilioProgrammableTextChat/TypingIndicator";
import { Client } from "@twilio/conversations";
import "./style.css";
import {
  getChatDetails,
  setAPIError,
  setTwilioError,
  setTwilioConversationSummary
} from "./../../../Redux/Actions/chat";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Spinner, Waiting } from "components/ui";
import { selectors } from "reducers";

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allowedChat: false,
      APIMembers: [],
      chatInitiate: false,
      messages: [],
      username: null,
      conversation: null,
      identity: "",
      jsonobject: {},
      participantName: "",
      participantSid: "",
      host: {},
      allowLeaveChat: false,
      showSpinner: false,
      typingParticipant: null,
      readInfo: {}
    };
    this.handleBeforeUnload = null;
  }

  static propTypes = {
    getChatDetails: PropTypes.func.isRequired,
    setAPIError: PropTypes.func.isRequired,
    setTwilioConversationSummary: PropTypes.func.isRequired,
    RoomDetails: PropTypes.object.isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string.isRequired
      })
    }),
    setTwilioError: PropTypes.func.isRequired,
    isLoader: PropTypes.bool,
    twilioErrorMessage: PropTypes.string,
    errorMessage: PropTypes.string,
    userId: PropTypes.string,
    LeaveChatSuccess: PropTypes.bool
  };

  // Throttle helper - prevents function from being called more than once per delay period
  throttle = (func, delay) => {
    let timeoutId = null;
    let lastCallTime = 0;

    return (...args) => {
      const now = Date.now();
      const timeSinceLastCall = now - lastCallTime;

      if (timeSinceLastCall >= delay) {
        lastCallTime = now;
        func(...args);
      } else {
        // Clear any pending call
        if (timeoutId) clearTimeout(timeoutId);
        // Schedule a call at the end of the throttle period
        timeoutId = setTimeout(() => {
          lastCallTime = Date.now();
          func(...args);
        }, delay - timeSinceLastCall);
      }
    };
  };

  handleTyping = () => {
    if (this.state.conversation) {
      this.state.conversation.typing();
    }
  };

  // Create throttled version (only call at most once per 3 seconds)
  handleTypingThrottled = this.throttle(this.handleTyping, 3000);

  handleInputFocus = () => {
    if (this.state.conversation && this.state.messages.length > 0) {
      const lastReceivedMessage = [...this.state.messages]
        .reverse()
        .find(msg => msg.authorId !== this.state.host.id);

      if (lastReceivedMessage && lastReceivedMessage.index !== undefined) {
        this.state.conversation
          .updateLastReadMessageIndex(lastReceivedMessage.index)
          .catch(error => {
            console.error("Failed to update read horizon:", error);
          });
      }
    }
  };

  componentDidMount() {
    let authDetails =
      JSON.parse(window.localStorage.getItem("evergreen")) &&
      JSON.parse(window.localStorage.getItem("evergreen"));
    if (authDetails && authDetails.twilio) {
      this.setState({
        identity: authDetails.first_name + " " + authDetails.last_name,
        twilioToken: authDetails.twilio.twilioToken
      });
    }

    let slot_id = "";
    if (this.props.match.params.id) {
      slot_id = this.props.match.params.id;
      this.props.setAPIError("");
      this.props.setTwilioError("");
      this.props.getChatDetails(slot_id, 1);
    } else {
      this.props.setAPIError("Facing issue to fetch details.");
    }
    if (this.state.APIMembers && this.state.APIMembers.length > 0) {
      this.setState({
        host: this.state.APIMembers.find(element => element.host === true)
      });
    }
  }

  componentWillUnmount() {
    if (this.handleBeforeUnload) {
      window.removeEventListener("beforeunload", this.handleBeforeUnload);
    }
  }

  static getDerivedStateFromProps(props) {
    if (
      props.RoomDetails &&
      props.RoomDetails.conversationSid &&
      props.RoomDetails.conversationSid.length > 0
    ) {
      return {
        conversationSid: props.RoomDetails.conversationSid,
        uniqueName: props.RoomDetails.uniqueName,
        friendlyName: props.RoomDetails.friendlyName,
        APIMembers: props.RoomDetails.members,
        allowLeaveChat: props.LeaveChatSuccess
      };
    }

    return null;
  }

  componentDidUpdate(prevProps) {
    // Only leave when allowLeaveChat transitions false → true to prevent multiple calls
    if (!prevProps.LeaveChatSuccess && this.props.LeaveChatSuccess) {
      this.leaveChatRoom();
    }

    if (
      !this.state.chatInitiate &&
      this.props.RoomDetails.friendlyName &&
      this.props.RoomDetails.conversationSid &&
      this.state.twilioToken
    ) {
      this.setState(
        {
          jsonobject: {
            identity: this.state.identity,
            token: this.state.twilioToken
          },
          host: this.state.APIMembers.find(element => element.host === true)
        },
        () => {
          this.initiateChat();
        }
      );
    }
  }

  initiateChat = () => {
    if (!this.state.chatInitiate) {
      this.getToken()
        .then(this.createChatClient)
        .then(this.joinConversation)
        .then(this.configureConversationEvents)
        .then(this.restoreMessages)
        .catch(error => {
          this.props.setTwilioError(error.message);
          this.addMessage({ body: error.message });
        });
    }
  };

  getToken = () => {
    return new Promise(resolve => {
      this.addMessage({
        body:
          "Please wait, connecting to room as " + this.state.identity + " ..."
      });
      this.setState({
        username: this.state.jsonobject.identity,
        chatInitiate: true
      });
      resolve(this.state.jsonobject);
    });
  };

  restoreMessages = async () => {
    try {
      if (this.conversation) {
        const { items = [] } = await this.conversation.getMessages();
        const restoredMessages = items.map(message => ({
          author: message.attributes?.authorName || "",
          body: message.body,
          dateCreated: message.dateCreated,
          timestamp: message.dateCreated,
          sid: message.sid,
          index: message.index,
          authorId: message.attributes?.authorId,
          attributes: message.attributes || {}
        }));
        this.setState({
          messages: [
            ...this.state.messages,
            ...restoredMessages.map(message => {
              if (message.author && message.author.length > 0) {
                const participantDetail =
                  this.state.APIMembers &&
                  this.state.APIMembers.length > 0 &&
                  this.state.APIMembers.filter(m => m.id === message.author) &&
                  this.state.APIMembers.filter(m => m.id === message.author)
                    .length > 0 &&
                  this.state.APIMembers.filter(m => m.id === message.author)[0];
                if (participantDetail) {
                  return {
                    ...message,
                    author: participantDetail.name,
                    authorId: message.author
                  };
                }
              }
              return message;
            })
          ]
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  createChatClient = () => {
    return new Promise((resolve, reject) => {
      Client.create(this.state.twilioToken)
        .then(client => {
          resolve(client);
        })
        .catch(error => reject(Error(error)));
    });
  };

  joinConversation = async chatClient => {
    try {
      const conversation = await chatClient.getConversationBySid(
        this.state.conversationSid
      );
      this.addMessage({ body: "Joining Chat Room..." });
      this.setState({ conversation });
      if (conversation.status !== "joined") {
        await conversation.join();
      }
      this.addMessage({ body: "Joined Chat Room..." });
      this.setState({
        allowedChat: true
      });
      this.handleBeforeUnload = () => conversation.leave();
      window.addEventListener("beforeunload", this.handleBeforeUnload);
      this.conversation = conversation;
      return conversation;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  addMessage = message => {
    if (message.author && message.author.length > 0) {
      const participantDetail =
        this.state.APIMembers &&
        this.state.APIMembers.length > 0 &&
        this.state.APIMembers.filter(m => m.id === message.author) &&
        this.state.APIMembers.filter(m => m.id === message.author).length > 0 &&
        this.state.APIMembers.filter(m => m.id === message.author)[0];
      if (participantDetail) {
        message.author = participantDetail.name;
      }
    }
    const messageData = { ...message };
    this.setState({
      messages: [...this.state.messages, messageData]
    });
  };

  getParticipantName = identity => {
    if (
      !identity ||
      !this.state.APIMembers ||
      this.state.APIMembers.length === 0
    ) {
      return null;
    }

    const participant = this.state.APIMembers.find(m => m.id === identity);
    return participant ? participant.name : null;
  };

  handleNewMessage = text => {
    if (this.state.conversation) {
      this.state.conversation.sendMessage(text, {
        authorName: this.state.username,
        authorId: this.state.host.id
      });
    }
  };

  configureConversationEvents = conversation => {
    conversation.on("messageAdded", message => {
      this.addMessage({
        author: message.attributes?.authorName || message.state?.author || "",
        body: message.body,
        dateCreated: message.dateCreated,
        timestamp: message.dateCreated,
        sid: message.sid,
        index: message.index,
        authorId: message.attributes?.authorId,
        attributes: message.attributes || {}
      });
    });

    conversation.on("participantJoined", member => {
      let PatientName = "Patient";
      const participantDetail =
        this.state.APIMembers &&
        this.state.APIMembers.length > 0 &&
        this.state.APIMembers.filter(m => m.id === member.identity) &&
        this.state.APIMembers.filter(m => m.id === member.identity).length >
          0 &&
        this.state.APIMembers.filter(m => m.id === member.identity)[0];
      if (participantDetail) {
        PatientName = participantDetail.name;
      }
      this.addMessage({ body: PatientName + ` has joined the room.` });
    });

    conversation.on("participantLeft", member => {
      let PatientName = "Patient";
      const participantDetail =
        this.state.APIMembers &&
        this.state.APIMembers.length > 0 &&
        this.state.APIMembers.filter(m => m.id === member.identity) &&
        this.state.APIMembers.filter(m => m.id === member.identity).length >
          0 &&
        this.state.APIMembers.filter(m => m.id === member.identity)[0];
      if (participantDetail) {
        PatientName = participantDetail.name;
      }
      this.addMessage({ body: PatientName + ` has left the room.` });
    });

    conversation.on("typingStarted", participant => {
      // Ignore if we're the one typing (participant.identity === host.id)
      if (participant.identity !== this.state.host.id) {
        this.setState({ typingParticipant: participant.identity });
      }
    });

    conversation.on("typingEnded", participant => {
      // Clear typing indicator if this participant was the one shown as typing
      if (this.state.typingParticipant === participant.identity) {
        this.setState({ typingParticipant: null });
      }
    });

    conversation.on("participantUpdated", ({ participant, updateReasons }) => {
      if (updateReasons.includes("lastReadMessageIndex") && participant.identity !== this.state.host.id ) {

        this.setState({
          readInfo: {
            msgIndex: participant.state.lastReadMessageIndex,
            timestamp: participant.state.lastReadTimestamp?.toISOString() || null,
            participantIdentity: participant.identity
          }
        });
      }
    });
  };

  leaveRoom = () => {
    this.setState({ showSpinner: true });
    this.props.setTwilioConversationSummary(
      this.state.messages,
      this.props.match.params.id
    );
  };

  leaveChatRoom = () => {
    return new Promise((resolve, reject) => {
      if (this.state.conversation) {
        this.state.conversation.removeAllListeners();
        this.state.conversation
          .leave()
          .then(() => {
            this.props.history.push("/chats/upcoming");
            resolve();
          })
          .catch(error => {
            this.setState({
              conversation: null
            });
            reject(error);
          });
      }
    });
  };

  refreshPage = () => {
    location.reload();
  };

  render() {
    return (
      <React.Fragment>
        <div className="dd_row">
          {this.props.RoomDetails.TextChatInitialize &&
            this.state.allowedChat && (
              <button
                disabled={this.state.showSpinner}
                onClick={this.leaveRoom}
                style={{ borderRadius: "15px" }}
              >
                Leave Room {this.state.showSpinner ? <Spinner /> : null}
              </button>
            )}
          {!this.props.isLoader &&
            this.props.twilioErrorMessage &&
            this.props.twilioErrorMessage.length > 0 && (
              <button onClick={this.refreshPage}>Re-Join</button>
            )}
          {this.props.isLoader && <Waiting />}
          {this.props.isLoader && <h2>Please wait to configured room..</h2>}
          {this.props.errorMessage && this.props.errorMessage.length > 0 && (
            <h2 style={{ color: "red" }}>{this.props.errorMessage}</h2>
          )}
          {this.props.RoomDetails.TextChatInitialize && (
            <div className="messageList-container">
              <div className="AppContainer-text">
                <MessageList
                  messages={this.state.messages}
                  host={this.state.host}
                  readInfo={this.state.readInfo}
                />

                {this.state.allowedChat && this.state.typingParticipant && (
                  <TypingIndicator
                    participantName={this.getParticipantName(
                      this.state.typingParticipant
                    )}
                  />
                )}

                {this.state.allowedChat && (
                  <MessageForm
                    onMessageSend={this.handleNewMessage}
                    onTyping={this.handleTypingThrottled}
                    onInputFocus={this.handleInputFocus}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  RoomDetails: state.getIn(["newRootReducer"]).rdc_chat.TextChatRoomDetails,
  errorMessage: state.getIn(["newRootReducer"]).rdc_chat.errorMessage,
  twilioErrorMessage: state.getIn(["newRootReducer"]).rdc_chat
    .twilioErrorMessage,
  isLoader: state.getIn(["newRootReducer"]).rdc_loader.isLoader,
  userId: selectors.getUserId(state),
  LeaveChatSuccess: state.getIn(["newRootReducer"]).rdc_chat.allowLeaveChat
});

export default connect(mapStateToProps, {
  getChatDetails,
  setAPIError,
  setTwilioError,
  setTwilioConversationSummary
})(withRouter(Index));
